<div class="padding-20">
    <div>
        <mat-grid-list cols="1" [rowHeight]="rowHeigthAdicao">
            <mat-grid-tile class="mat-grid-tile-height">
                <div>
                    <div class="margin-10">
                        <mat-label class="label-titulo flex-center-if-mobile">Adicionar banner</mat-label>
                    </div>
                    <div>
                        <mat-card appearance="outlined" [formGroup]="formBannerGravar" >
                            <mat-card-content class="mat-card-content" >
                                <app-consulta-customizada matInput class="form-field-material" [labelDaDescricao]="'Filial'" [identificador]="'cntFilial'"
                                    [campoFiltro]="'CD_FILIAL,NM_FILIAL'" [lookupExibicao]="['CD_FILIAL', 'NM_FILIAL']"
                                    complementoConsulta=""
                                    (itemCosulta)="receberItemConsultaFilial($event)" [campoRequerido]="!formBannerGravar.get('flTelaLogin').value" [disabled]="formBannerGravar.get('flTelaLogin').value" [limparCampo]="limparCampoSalvar">
                                </app-consulta-customizada>
                                <mat-form-field appearance="fill">
                                    <mat-label>Início</mat-label>
                                    <input matInput [matDatepicker]="dataInicialGravar" class="input" formControlName="dataInicio" />
                                    <mat-datepicker-toggle matSuffix [for]="dataInicialGravar"></mat-datepicker-toggle>
                                    <mat-datepicker class="mat-calendar" #dataInicialGravar></mat-datepicker>
                                    @if (formBannerGravar.get('dataInicio').invalid) {
                                    <mat-error>Data inválida</mat-error>
                                    }
                                </mat-form-field>

                                <mat-form-field appearance="fill">
                                    <mat-label>Fim</mat-label>
                                    <input matInput [matDatepicker]="dataFinalGravar" class="input" formControlName="dataFim" />
                                    <mat-datepicker-toggle matSuffix [for]="dataFinalGravar"></mat-datepicker-toggle>
                                    <mat-datepicker class="mat-calendar" #dataFinalGravar></mat-datepicker>
                                    @if (formBannerGravar.get('dataFim').invalid) {
                                    <mat-error>Data inválida</mat-error>
                                    }
                                </mat-form-field>

                                <app-consulta-customizada matInput class="form-field-material" [labelDaDescricao]="'Ação'" [identificador]="'cntAcessoAcao'"
                                        [campoFiltro]="'CD_ACESSO,NM_ACAO'" [lookupExibicao]="['CD_ACESSO', 'NM_ACAO']"
                                        complementoConsulta="fl_classificacao in ('R','G','L')"
                                        (itemCosulta)="receberItemConsultaAcesso($event)" [campoRequerido]="false" [disabled]="formBannerGravar.get('flTelaLogin').value" [limparCampo]="limparCampoSalvar">
                                    </app-consulta-customizada>
                                <mat-form-field appearance="fill">
                                    <mat-label>Ordem</mat-label>
                                    <input matInput class="input" formControlName="ordem"/>
                                </mat-form-field>
                                <mat-form-field appearance="fill">
                                    <mat-label>Imagem</mat-label>

                                    <input
                                        matInput
                                        formControlName="img"
                                        [value]="nomeArquivoSelecionado"
                                        readonly
                                    >

                                    <button mat-icon-button matSuffix (click)="fileInput.click()">
                                        <mat-icon>attach_file</mat-icon>
                                    </button>
                                    <mat-hint class="hint-resolucao">
                                        {{ formBannerGravar.get('flTelaLogin').value
                                            ? 'Min: 800x900 | Máx: 1080x1200'
                                            : 'Min: 1280x400 | Máx: 1920x600' }}
                                    </mat-hint>
                                </mat-form-field>

                                <input
                                    #fileInput
                                    type="file"
                                    hidden
                                    (change)="onFileSelected($event)"
                                    accept="image/*"
                                    required=true
                                />

                                <mat-checkbox formControlName="flTelaLogin">Tela de login</mat-checkbox>
                                <div class="padding-10">
                                    <button class="botao-form" mat-flat-button color="primary" (click)="salvar()" >
                                        Salvar
                                    </button>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </mat-grid-tile>
        </mat-grid-list>
        @if (banners?.length > 0) {
        <div class="margin-top-10">
            <div class="margin-10">
                <mat-label class="label-titulo flex-center-if-mobile">Lista de banners</mat-label>
            </div>
            @for (banner of banners; track banner; let i = $index) {
            <mat-accordion>
                <mat-expansion-panel class="margin-bottom-10"  hideTogle>
                    <mat-expansion-panel-header [ngClass]="isLayoutMobile ? 'height-mobile':'' ">
                        <mat-panel-title>
                           {{banner.nomeImg}} {{banner.cdAcesso ? ('- Ação: '+ banner.cdAcesso) : ''}}
                        </mat-panel-title>
                        <mat-panel-description>
                            {{banner.cdFilial ? ('Filial: '+ banner.cdFilial + '| ') : ''}} De: {{((banner.dataInicio))}} | Até: {{banner.dataFim}} | {{banner.cdAcesso ? ('Código de acesso: ' + banner.cdAcesso + '| ') : ''}} Ordem: {{banner.ordem}}
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div>
                        <mat-grid-list cols="1" [rowHeight]="(rowHeigthEdicao)">
                            <mat-grid-tile>
                                <mat-card appearance="outlined">
                                    <mat-card-content class="mat-card-content" [formGroup]="banner.form">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Id Geral</mat-label>
                                            <input matInput class="input"  formControlName="idGeral" disabled="true" readonly="true"/>
                                        </mat-form-field>
                                        <app-consulta-customizada maxInput class="form-field-material" [labelDaDescricao]="'Filial'" [identificador]="'cntFilial'"
                                            [campoFiltro]="'CD_FILIAL,NM_FILIAL'" [campoChaveDoFiltro]="'CD_FILIAL'" [lookupExibicao]="['CD_FILIAL', 'NM_FILIAL']"
                                            [complementoConsulta]="''" [possuiItemInicial]="banner.form.get('cdFilial').value !== null ? true : false" [itemInicial]="banner.cdFilial" (itemCosulta)="receberItemConsultaFilialEditar($event, banner)"
                                            [disabled]="banner.form.get('flTelaLogin').value" [campoRequerido]="!banner.form.get('flTelaLogin').value" [limparCampo]="limparCampoSalvar">
                                        </app-consulta-customizada>
                                        <mat-form-field appearance="fill" >
                                            <mat-label>Inicio</mat-label>
                                            <input matInput [matDatepicker]="dataInicialEditar" class="input" formControlName="dataInicio"/>
                                            <mat-datepicker-toggle matSuffix [for]="dataInicialEditar"></mat-datepicker-toggle>
                                            <mat-datepicker class="mat-calendar" #dataInicialEditar></mat-datepicker>
                                            @if (banner.form.get('dataInicio').invalid) {
                                            <mat-error>Data inválida</mat-error>
                                            }
                                        </mat-form-field>
                                        <mat-form-field appearance="fill" >
                                            <mat-label>Fim</mat-label>
                                            <input matInput [matDatepicker]="dataFinalEditar" class="input" formControlName="dataFim" />
                                            <mat-datepicker-toggle matSuffix [for]="dataFinalEditar"></mat-datepicker-toggle>
                                            <mat-datepicker class="mat-calendar" #dataFinalEditar></mat-datepicker>
                                            @if (banner.form.get('dataFim').invalid) {
                                            <mat-error>Data inválida</mat-error>
                                            }
                                        </mat-form-field>
                                        <app-consulta-customizada maxInput class="form-field-material" [labelDaDescricao]="'Ação'" [identificador]="'cntAcessoAcao'"
                                                [campoFiltro]="'CD_ACESSO,NM_ACAO'" [campoChaveDoFiltro]="'CD_ACESSO'" [lookupExibicao]="['CD_ACESSO', 'NM_ACAO']"
                                                complementoConsulta="fl_classificacao in ('R','G','L')" [possuiItemInicial]="banner.form.get('cdAcesso').value !== null ? true : false"
                                                [itemInicial]="banner.cdAcesso"
                                                (itemCosulta)="receberItemConsultaAcessoEditar($event, banner)" [disabled]="banner.form.get('flTelaLogin').value" [limparCampo]="limparCampoSalvar">
                                            </app-consulta-customizada>
                                        <mat-form-field appearance="fill">
                                            <mat-label>Ordem</mat-label>
                                            <input matInput class="input" formControlName="ordem"/>
                                        </mat-form-field>
                                        <mat-form-field appearance="fill">
                                            <mat-label>Imagem</mat-label>
                                            <input
                                                matInput
                                                [value]="banner.form.get('nomeImg').value"
                                                readonly
                                            >
                                            <button mat-icon-button matSuffix (click)="fileInputEditar.click()">
                                                <mat-icon   mat-icon>attach_file</mat-icon>
                                            </button>
                                            <mat-hint class="hint-resolucao">
                                                {{ banner.form.get('flTelaLogin').value
                                                    ? 'Min: 800x900 | Máx: 1080x1200'
                                                    : 'Min: 1280x400 | Máx: 1920x600' }}
                                            </mat-hint>
                                        </mat-form-field>

                                        <input
                                            #fileInputEditar
                                            type="file"
                                            hidden
                                            (change)="onFileSelectedEditar($event, banner)"
                                            accept="image/*"
                                        />
                                        <mat-checkbox
                                            formControlName="flTelaLogin">Tela de login
                                        </mat-checkbox>
                                        <div class="botao">
                                            <button class="botao-editar-form" mat-flat-button color="primary" (click)="editar(banner)">
                                                Editar
                                            </button>
                                            @if (this.rowHeigthEdicao === 635) {
                                            <button class="botao-editar-form" mat-flat-button color="warn"(click)="excluir(banner)" >
                                                Excluir
                                            </button>
                                            }
                                        </div>
                                        @if (this.rowHeigthEdicao !== 635) {
                                        <div class="botao">
                                            <button class="botao-editar-form" mat-flat-button color="warn" (click)="excluir(banner)">
                                                Excluir
                                            </button>
                                        </div>
                                        }
                                    </mat-card-content>
                                </mat-card>
                            </mat-grid-tile>
                        </mat-grid-list>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            }
        </div>
        }
    </div>
</div>
<app-rodape></app-rodape>
